"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8759],{

/***/ 68759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$B": function() { return /* binding */ MARKETING_SMS_CONSENT; },
/* harmony export */   "N4": function() { return /* binding */ AccountFormHeader; },
/* harmony export */   "OR": function() { return /* binding */ AccountFormWrapper; },
/* harmony export */   "em": function() { return /* binding */ Disclaimer; },
/* harmony export */   "l0": function() { return /* binding */ Form; },
/* harmony export */   "lX": function() { return /* binding */ EmailDisclaimerText; },
/* harmony export */   "n5": function() { return /* binding */ FormWrapper; }
/* harmony export */ });
/* unused harmony exports CONSENT_VERSIONS, PHONE_DEFAULT_DISCLAIMER */
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96649);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82772);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96078);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9653);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(2490);
/* harmony import */ var core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_constructor_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(59849);
/* harmony import */ var core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_filter_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(34514);
/* harmony import */ var core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_iterator_for_each_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(82110);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(22470);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(76614);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(46523);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
























var _excluded = [
    "children"
], _excluded2 = [
    "children",
    "desktopNoWrap",
    "shouldRenderDisclaimerAboveCTA"
];
function cov_2abro87rr() {
    var path = "/__w/code/code/js/packages/cinderblocks/src/platform/auth/shared.tsx";
    var hash = "f6273cb2a7510d0e149d17e8f20dc32bdb146053";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/__w/code/code/js/packages/cinderblocks/src/platform/auth/shared.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 37,
                    column: 63
                },
                end: {
                    line: 80,
                    column: 1
                }
            },
            "1": {
                start: {
                    line: 42,
                    column: 6
                },
                end: {
                    line: 42,
                    column: 107
                }
            },
            "2": {
                start: {
                    line: 44,
                    column: 6
                },
                end: {
                    line: 44,
                    column: 299
                }
            },
            "3": {
                start: {
                    line: 53,
                    column: 6
                },
                end: {
                    line: 77,
                    column: 9
                }
            },
            "4": {
                start: {
                    line: 84,
                    column: 40
                },
                end: {
                    line: 84,
                    column: 58
                }
            },
            "5": {
                start: {
                    line: 86,
                    column: 37
                },
                end: {
                    line: 89,
                    column: 1
                }
            },
            "6": {
                start: {
                    line: 97,
                    column: 72
                },
                end: {
                    line: 113,
                    column: 1
                }
            },
            "7": {
                start: {
                    line: 98,
                    column: 2
                },
                end: {
                    line: 112,
                    column: 4
                }
            },
            "8": {
                start: {
                    line: 115,
                    column: 82
                },
                end: {
                    line: 124,
                    column: 1
                }
            },
            "9": {
                start: {
                    line: 119,
                    column: 2
                },
                end: {
                    line: 123,
                    column: 4
                }
            },
            "10": {
                start: {
                    line: 126,
                    column: 54
                },
                end: {
                    line: 128,
                    column: 1
                }
            },
            "11": {
                start: {
                    line: 127,
                    column: 2
                },
                end: {
                    line: 127,
                    column: 41
                }
            },
            "12": {
                start: {
                    line: 130,
                    column: 47
                },
                end: {
                    line: 132,
                    column: 1
                }
            },
            "13": {
                start: {
                    line: 131,
                    column: 2
                },
                end: {
                    line: 131,
                    column: 64
                }
            },
            "14": {
                start: {
                    line: 139,
                    column: 40
                },
                end: {
                    line: 141,
                    column: 1
                }
            },
            "15": {
                start: {
                    line: 140,
                    column: 2
                },
                end: {
                    line: 140,
                    column: 48
                }
            },
            "16": {
                start: {
                    line: 144,
                    column: 20
                },
                end: {
                    line: 147,
                    column: 1
                }
            },
            "17": {
                start: {
                    line: 151,
                    column: 4
                },
                end: {
                    line: 165,
                    column: 1
                }
            },
            "18": {
                start: {
                    line: 152,
                    column: 2
                },
                end: {
                    line: 164,
                    column: 4
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 41,
                        column: 18
                    },
                    end: {
                        line: 41,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 42,
                        column: 6
                    },
                    end: {
                        line: 42,
                        column: 107
                    }
                },
                line: 42
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 43,
                        column: 10
                    },
                    end: {
                        line: 43,
                        column: 11
                    }
                },
                loc: {
                    start: {
                        line: 44,
                        column: 6
                    },
                    end: {
                        line: 44,
                        column: 299
                    }
                },
                line: 44
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 45,
                        column: 24
                    },
                    end: {
                        line: 45,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 53,
                        column: 6
                    },
                    end: {
                        line: 77,
                        column: 9
                    }
                },
                line: 53
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 97,
                        column: 72
                    },
                    end: {
                        line: 97,
                        column: 73
                    }
                },
                loc: {
                    start: {
                        line: 97,
                        column: 95
                    },
                    end: {
                        line: 113,
                        column: 1
                    }
                },
                line: 97
            },
            "4": {
                name: "(anonymous_4)",
                decl: {
                    start: {
                        line: 115,
                        column: 82
                    },
                    end: {
                        line: 115,
                        column: 83
                    }
                },
                loc: {
                    start: {
                        line: 118,
                        column: 6
                    },
                    end: {
                        line: 124,
                        column: 1
                    }
                },
                line: 118
            },
            "5": {
                name: "(anonymous_5)",
                decl: {
                    start: {
                        line: 126,
                        column: 54
                    },
                    end: {
                        line: 126,
                        column: 55
                    }
                },
                loc: {
                    start: {
                        line: 126,
                        column: 65
                    },
                    end: {
                        line: 128,
                        column: 1
                    }
                },
                line: 126
            },
            "6": {
                name: "(anonymous_6)",
                decl: {
                    start: {
                        line: 130,
                        column: 47
                    },
                    end: {
                        line: 130,
                        column: 48
                    }
                },
                loc: {
                    start: {
                        line: 130,
                        column: 58
                    },
                    end: {
                        line: 132,
                        column: 1
                    }
                },
                line: 130
            },
            "7": {
                name: "(anonymous_7)",
                decl: {
                    start: {
                        line: 139,
                        column: 40
                    },
                    end: {
                        line: 139,
                        column: 41
                    }
                },
                loc: {
                    start: {
                        line: 139,
                        column: 64
                    },
                    end: {
                        line: 141,
                        column: 1
                    }
                },
                line: 139
            },
            "8": {
                name: "(anonymous_8)",
                decl: {
                    start: {
                        line: 151,
                        column: 4
                    },
                    end: {
                        line: 151,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 151,
                        column: 87
                    },
                    end: {
                        line: 165,
                        column: 1
                    }
                },
                line: 151
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 49,
                        column: 6
                    },
                    end: {
                        line: 49,
                        column: 49
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 49,
                            column: 15
                        },
                        end: {
                            line: 49,
                            column: 49
                        }
                    }
                ],
                line: 49
            },
            "1": {
                loc: {
                    start: {
                        line: 50,
                        column: 6
                    },
                    end: {
                        line: 50,
                        column: 55
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 50,
                            column: 19
                        },
                        end: {
                            line: 50,
                            column: 55
                        }
                    }
                ],
                line: 50
            },
            "2": {
                loc: {
                    start: {
                        line: 51,
                        column: 6
                    },
                    end: {
                        line: 51,
                        column: 20
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 51,
                            column: 18
                        },
                        end: {
                            line: 51,
                            column: 20
                        }
                    }
                ],
                line: 51
            },
            "3": {
                loc: {
                    start: {
                        line: 151,
                        column: 17
                    },
                    end: {
                        line: 151,
                        column: 38
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 151,
                            column: 33
                        },
                        end: {
                            line: 151,
                            column: 38
                        }
                    }
                ],
                line: 151
            },
            "4": {
                loc: {
                    start: {
                        line: 159,
                        column: 23
                    },
                    end: {
                        line: 159,
                        column: 75
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 159,
                            column: 39
                        },
                        end: {
                            line: 159,
                            column: 63
                        }
                    },
                    {
                        start: {
                            line: 159,
                            column: 66
                        },
                        end: {
                            line: 159,
                            column: 75
                        }
                    }
                ],
                line: 159
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0
        },
        b: {
            "0": [
                0
            ],
            "1": [
                0
            ],
            "2": [
                0
            ],
            "3": [
                0
            ],
            "4": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "f6273cb2a7510d0e149d17e8f20dc32bdb146053"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_2abro87rr = function cov_2abro87rr() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_2abro87rr();
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Versioned marketing SMS consent language registry.
 *
 * All surfaces that display marketing SMS consent copy should import
 * MARKETING_SMS_CONSENT from here.
 */ 

// ---------------------------------------------------------------------------
// Consent language registry
// ---------------------------------------------------------------------------
// DO NOT MODIFY EXISTING ENTRIES. IF YOU NEED TO UPDATE THE CONSENT LANGUAGE, ADD A NEW ENTRY TO THE OBJECT.
// WHEN LEGAL UPDATES THE COPY:
//   1. Add a new entry to CONSENT_VERSIONS (do NOT modify existing entries)
//   2. Update CURRENT_VERSION to point to the new key
//   3. Update the test
var CONSENT_VERSIONS = (cov_2abro87rr().s[0]++, {
    marketing_sms_v1: {
        checkboxLabel: "I consent to receive marketing calls and texts from Opendoor and its affiliates to the number provided. I understand that I may opt out at any time and consent is not a condition of purchase.",
        ctaAgreement: function ctaAgreement(ctaText) {
            cov_2abro87rr().f[0]++;
            cov_2abro87rr().s[1]++;
            return "By pressing “".concat(ctaText, ",” I agree to Opendoor’s Terms of Service and Privacy Policy.");
        },
        full: function full(ctaText) {
            cov_2abro87rr().f[1]++;
            cov_2abro87rr().s[2]++;
            return "I consent to receive marketing calls and texts from Opendoor and its affiliates to the number provided. I understand that I may opt out at any time and consent is not a condition of purchase. By pressing “".concat(ctaText, ",” I agree to Opendoor’s Terms of Service and Privacy Policy.");
        },
        CtaAgreementLinked: function CtaAgreementLinked(_ref) {
            var ctaText = _ref.ctaText, tosAnalyticsName = _ref.tosAnalyticsName, privacyAnalyticsName = _ref.privacyAnalyticsName, _ref$tosUrl = _ref.tosUrl, tosUrl = _ref$tosUrl === void 0 ? (cov_2abro87rr().b[0][0]++, "https://www.opendoor.com/w/terms") : _ref$tosUrl, _ref$privacyUrl = _ref.privacyUrl, privacyUrl = _ref$privacyUrl === void 0 ? (cov_2abro87rr().b[1][0]++, "https://www.opendoor.com/w/privacy") : _ref$privacyUrl, _ref$linkProps = _ref.linkProps, linkProps = _ref$linkProps === void 0 ? (cov_2abro87rr().b[2][0]++, {}) : _ref$linkProps;
            cov_2abro87rr().f[2]++;
            cov_2abro87rr().s[3]++;
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_24__.createElement(react__WEBPACK_IMPORTED_MODULE_24__.Fragment, null, "By pressing “", ctaText, ",” I agree to Opendoor’s", " ", /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_24__.createElement(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_25__/* .Link */ .r, _extends({
                analyticsName: tosAnalyticsName,
                href: tosUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                "aria-label": "Opens a new page with Opendoor’s terms of service"
            }, linkProps), "Terms of Service"), " ", "and", " ", /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_24__.createElement(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_25__/* .Link */ .r, _extends({
                analyticsName: privacyAnalyticsName,
                href: privacyUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                "aria-label": "Opens a new page with Opendoor’s privacy policy"
            }, linkProps), "Privacy Policy"), ".");
        }
    }
});
var CURRENT_VERSION = (cov_2abro87rr().s[4]++, "marketing_sms_v1");
var MARKETING_SMS_CONSENT = (cov_2abro87rr().s[5]++, _objectSpread({
    version: CURRENT_VERSION
}, CONSENT_VERSIONS[CURRENT_VERSION]));

// ---------------------------------------------------------------------------
// Shared auth UI components
// ---------------------------------------------------------------------------
cov_2abro87rr().s[6]++;
var EmailDisclaimerText = function EmailDisclaimerText(_ref2) {
    var analyticsName = _ref2.analyticsName;
    cov_2abro87rr().f[3]++;
    cov_2abro87rr().s[7]++;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_24__.createElement(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_26__/* .Text */ .x, {
        tag: "p",
        typography: "$bodyXsmall",
        whiteSpace: "normal",
        $largerThanSM: {
            whiteSpace: "nowrap"
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_24__.createElement(MARKETING_SMS_CONSENT.CtaAgreementLinked, {
        ctaText: "Continue",
        tosAnalyticsName: "".concat(analyticsName, "-terms"),
        privacyAnalyticsName: "".concat(analyticsName, "-privacy-policy"),
        linkProps: {
            variant: "primary",
            size: "xsmall"
        }
    }));
};
cov_2abro87rr().s[8]++;
var AccountFormHeader = function AccountFormHeader(_ref3) {
    var children = _ref3.children, rest = _objectWithoutProperties(_ref3, _excluded);
    cov_2abro87rr().f[4]++;
    cov_2abro87rr().s[9]++;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_24__.createElement(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_26__/* .Text */ .x, _extends({
        tag: "h1",
        typography: "$headerMedium"
    }, rest, {
        marginBottom: "$10x",
        textAlign: "left"
    }), children);
};
cov_2abro87rr().s[10]++;
var AccountFormWrapper = function AccountFormWrapper(props) {
    cov_2abro87rr().f[5]++;
    cov_2abro87rr().s[11]++;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_24__.createElement(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_27__/* .Box */ .x, _extends({
        width: "100%"
    }, props));
};
cov_2abro87rr().s[12]++;
var FormWrapper = function FormWrapper(props) {
    cov_2abro87rr().f[6]++;
    cov_2abro87rr().s[13]++;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_24__.createElement(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_27__/* .Box */ .x, _extends({
        width: "100%",
        flexDirection: "column"
    }, props));
};
cov_2abro87rr().s[14]++;
var PHONE_DEFAULT_DISCLAIMER = function PHONE_DEFAULT_DISCLAIMER(actionText) {
    cov_2abro87rr().f[7]++;
    cov_2abro87rr().s[15]++;
    return MARKETING_SMS_CONSENT.full(actionText);
};
// eslint-disable-next-line no-restricted-syntax
var Form = (cov_2abro87rr().s[16]++, /*#__PURE__*/ (0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)("form",  true ? {
    target: "e1a669rm0"
} : 0)( true ? {
    name: "g0ogvo",
    styles: "width:100%;margin-top:28px"
} : 0));
cov_2abro87rr().s[17]++;
var Disclaimer = function Disclaimer(_ref4) {
    var children = _ref4.children, _ref4$desktopNoWrap = _ref4.desktopNoWrap, desktopNoWrap = _ref4$desktopNoWrap === void 0 ? (cov_2abro87rr().b[3][0]++, false) : _ref4$desktopNoWrap, shouldRenderDisclaimerAboveCTA = _ref4.shouldRenderDisclaimerAboveCTA, props = _objectWithoutProperties(_ref4, _excluded2);
    cov_2abro87rr().f[8]++;
    cov_2abro87rr().s[18]++;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_24__.createElement(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_27__/* .Box */ .x, props, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_24__.createElement(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_26__/* .Text */ .x, {
        tag: "p",
        typography: "$bodyXsmall",
        color: "$contentSecondary",
        whiteSpace: "normal",
        $largerThanSM: desktopNoWrap ? (cov_2abro87rr().b[4][0]++, {
            whiteSpace: "nowrap"
        }) : (cov_2abro87rr().b[4][1]++, undefined)
    }, children));
}; //# sourceMappingURL=shared.mjs.map


/***/ })

}]);